import { render, staticRenderFns } from "./english.vue?vue&type=template&id=25803d8a&scoped=true&"
import script from "./english.vue?vue&type=script&lang=js&"
export * from "./english.vue?vue&type=script&lang=js&"
import style0 from "./english.vue?vue&type=style&index=0&id=25803d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25803d8a",
  null
  
)

export default component.exports